import { Component } from 'src/utils';
import homeArrow from './../../../images/home-arrow.png';
import logoIcon from './../../../images/small-logo.png';
import houseIcon from './../../../images/house-icon.png';
import birdFood from './../../../images/bird-food.png';
import searchIcon from './../../../images/search.png';
import template from './subscription-product.html';

@Component({
  controllerAs: 'product',
  template
})

export default class Product  {
  static $inject = [
    '$scope',
    '$ngRedux',
    '$stateParams',
    '$state',
    'toaster',
    'orderService',
    'spinnerService',
    'orderActions',
    'authService',
    '$window',
    'APP'
  ];

  constructor($scope, $ngRedux, $stateParams, $state, $toaster, 
    $order, $spinner, orderActions, $auth, $window, APP) {
    const disconnect = $ngRedux.connect(this.mapState)(this);

    this.homeArrow = homeArrow;
    this.logoIcon = logoIcon;
    this.houseIcon = houseIcon;
    this.birdFood = birdFood;
    this.$state = $state;
    this.$toaster = $toaster;
    this.$auth = $auth;
    this.$stateParams = $stateParams;
    this.$window = $window;
    
    
    this.APP = APP;
   
    this.searchIcon = searchIcon;
    $ngRedux.dispatch(orderActions.setProducts([]));
    $spinner.show('appSpinner');
    this.isCallingAPI = true;
    $order.getSubcribableProducts('seed')
        .finally(() => {
      $spinner.hide('appSpinner');
    this.isCallingAPI = false;
  });


    $scope.$on('$destroy', disconnect);
  }

  mapState(state) {
    return {
      profile: state.auth.profile,
      list: state.order.subscribableProducts
    };
  }

  goToHomePage() {
    let storeName = '';
    if (this.$stateParams.storeName && this.$stateParams.storeName != this.APP.ORDER.ORDER_URL.browseUrl) {
      storeName = this.$stateParams.storeName;
    } else {
      if (this.profile.store && this.profile.store.storeName) {
        storeName = this.profile.store.storeURLName;
      } else {
        storeName = this.$auth.getGuestStoreDetail().storeName;
      }
    }
    if (storeName) {
      this.$window.location.href = '/' + storeName;
    } else {
      this.$state.go('home');

    }
  }

  isCategorySubcatSame() {
    return this.list.length && (this.list[0].itemList[0].masterProduct.subCategories[0].name ===
      this.list[0].itemList[0].masterProduct.subCategories[0].category.name);
  }

  // parent is subcategory or category depending on subcategory existance
  getParentDetails() {
    if (this.isCategorySubcatSame()) {
      return this.list[0].itemList[0].masterProduct.subCategories[0].category;
    }
    else {
      return this.list.length && this.list[0].itemList[0].masterProduct.subCategories[0];
    }
  }

  goToDSCDetailPage() {
    //  console.log('goToDSCDetailPage');
    this.$state.go('savings-club');
  }
  goToSubscriptionDetail(){
    var subScribedInfo = this.$auth.getSubscribedInfo();
    if (subScribedInfo){
      this.$state.go('subscription-detail', {subscriptionId: subScribedInfo.id, option: subScribedInfo.option});
    }
  }
  goToProductPage(item) {

    let storeName = '';
    if(this.$stateParams.storeName) {
      storeName = this.$stateParams.storeName;
    }
    else {
      if(this.profile.store && this.profile.store.storeName) {
        storeName = this.profile.store.storeURLName;
      } else {
       storeName = this.$auth.getGuestStoreDetail().storeName;
      }
    }
    // let storeName =  false;
    if (storeName) {
      this.$state.go('product.detail', {
        categoryId: item.masterProduct.category.prettyUrl, 
        subCategoryId: item.masterProduct.subCategories[0].prettyUrl, 
        productId: item.masterProduct.prettyUrl,
        itemGroupNumber: item.masterProduct.itemGroupNumber,
        storeName: storeName,
        forSubscription:true
       });
    }
    else {
      this.$state.go('browse-product.detail', {
        categoryId: item.masterProduct.category.prettyUrl, 
        subCategoryId: item.masterProduct.subCategories[0].prettyUrl, 
        productId: item.masterProduct.prettyUrl,
        itemGroupNumber: item.masterProduct.itemGroupNumber,
        forSubscription:true
       });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/order/subscription/subscription-product.js